import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="logo">
              <img src="/images/logo-light.png" alt="Logo light" className="logo-light" />   
            </div>
            <p>
              Servicios de barras moviles profesionales para hacer de tu evento
              una experiencia inolvidable.
            </p>
          </div>
          <div className="footer-section">
            <h4>Enlaces Rápidos</h4>
            <ul>
              <li>
                <a href="#inicio" onClick={(e) => { e.preventDefault(); scrollToSection('inicio'); }}>
                  Inicio
                </a>
              </li>
              <li>
                <a href="#servicios" onClick={(e) => { e.preventDefault(); scrollToSection('servicios'); }}>
                  Servicios
                </a>
              </li>
              <li>
                <a href="#nosotros" onClick={(e) => { e.preventDefault(); scrollToSection('nosotros'); }}>
                  Nosotros
                </a>
              </li>
              <li>
                <a href="#galeria" onClick={(e) => { e.preventDefault(); scrollToSection('galeria'); }}>
                  Galería
                </a>
              </li>
              <li>
                <a href="#contacto" onClick={(e) => { e.preventDefault(); scrollToSection('contacto'); }}>
                  Contacto
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contacto</h4>
            <ul>
              <li>📧 consultas@emiliabarrasmoviles.com</li>
              <li>📱 Germán Draghi 11-2501-2200 | 
                      Julian Pagliarulo 2477-313171</li>
              <li>📍Showroom y oficinas Bv Ameghino 555 (2700) Pergamino Buenos Aires. Servicios en Pergamino y zona.</li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Seguinos</h4>
            <div className="social-links">
             {/*  <a href="#" aria-label="Facebook">📘</a> */}
             <a href="https://www.instagram.com/emilia.barrasmoviles" 
             aria-label="Facebook" 
             style={{ color: 'white', fontSize: '14px' }}
             
             >
              <img
                src="/images/instagram.svg"
                alt="Instagram"
                className="instagram-icon"
              />@emiliabarrasmoviles </a>
{/*               <a href="https://www.instagram.com/emilia.barrasmoviles" aria-label="Instagram">📷</a> */}
              {/* <a href="#" aria-label="Twitter">🐦</a> */}
            </div>
            <a
              href="https://wa.me/5491125012200"
              className="whatsapp-float"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Contactar por WhatsApp"
            >
              <img
                src="/images/whatsapp.svg"
                alt="WhatsApp"
              />
            </a>


          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Emilia barras moviles. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
